/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/trash'
export default icon
